import React, { useState, useEffect } from 'react';
import { useDispatch, connect } from 'react-redux';
import { usePopup } from '../../context/PopupContext';
import { setResumeFormat, updateFinalTargetLink } from '../../services/actions/actions';
import { COOKIE_DOMAIN, MEMBERSHIP, REFRESH_LINK } from '../../constants/constants';
import { getResumeName as getResumeNameFromHelper, getLetterName } from '../../helper';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const DownloadPopup = (props) => {
    const history = useHistory()
    const dispatch = useDispatch();
    const { boxContent, close, status, rightCallbackAction, leftCallbackAction, data, waiting, setWaiting } = usePopup();
    const [activeFormat, setActiveFormat] = useState('pdf');
    const [downloadText, setDownloadText] = useState();
    const [entity, setEntity] = useState({type: '', name: ''})

    // useEffect(() => {
    //     if(typeof data != 'undefined'){
    //         let downloadFormat = (data.plan == 'pro' ? props.downloadFormat : 'text'); 
    //         dispatch(setResumeFormat(downloadFormat));
    //         setActiveFormat(downloadFormat);
    //     }
    // }, [data]);

    // Array for static text which is showing on downloading popup.
    const downloadingText =  [`Getting your ${entity.name} ready`, 'Applying customizations', 'Ready to download'];

    useEffect(() => {
        setActiveFormat(props.downloadFormat);
    })

    useEffect(() => {
        unsetEntity();
        if(data?.entity) setEntity(data.entity)
    }, [data]);

    // Preparing text after open the popup for download
    // console.log(activeFormat);
    
    const showDownloadProgress = (() => {
        let i = 0;
        return function(){
            setDownloadText(downloadingText[i]);
            if(i < 2){
                setTimeout(() => {
                    showDownloadProgress();
                }, 3000)
            }
            i += 1;
        }
    })();
    
    const entityFormatHandler = (e) => {
        dispatch(setResumeFormat(e.target.value));
        setActiveFormat(e.target.value);
        // if(typeof data != 'undefined' && data.plan != 'pro' && e.target.value != 'text'){
        //     localStorage.setItem('downloadFormat', e.target.value);
        // }
    }

    const unsetEntity = () => {
        setEntity({type: '', name: ''});
    }

    const getResumeName = () => {
        let resumeName = '';
        if (window.location.pathname === '/') {
            resumeName = localStorage.getItem('resumeName');
        } else {
            resumeName = getResumeNameFromHelper(props.resume);
        }
        return resumeName;
    }

    const removeLocalItems = () => {
        const downloadOnAllinonePageLoad = (localStorage.getItem('downloadOnAllinonePageLoad') ?? false);
        if(downloadOnAllinonePageLoad) localStorage.removeItem('downloadOnAllinonePageLoad');
        localStorage.removeItem('clickAction');
        const resumeName = (localStorage.getItem('resumeName') ?? false);
        if(resumeName) localStorage.removeItem('resumeName');
    }

    const leftButtonClickHandler = () => {
        unsetEntity();
        leftCallbackAction();
        dispatch(setResumeFormat('pdf'));
    }

    const rightButtonClickHandler = () => {
        if(typeof data != 'undefined' && data.plan != 'pro' && activeFormat != 'text'){
            //this will be used to redirect back on page and open download popup But not for dashboard
            data?.referrer !== 'dashboard' && entity?.type == 'coverletter' && localStorage.setItem('clickAction', 'cl_download');
            //window.location.href = MEMBERSHIP; //useHistory doesn't work here, therefore, used window.location.href
            const url = Cookies.get('redirect_to', { domain: COOKIE_DOMAIN, path: "/" })
            dispatch(updateFinalTargetLink({link: url}));
                // setTimeout(() => {
                //     history.push(REFRESH_LINK);
                // }, 100);
        }else{
            rightCallbackAction(false, {downloadFormat: activeFormat});
            dispatch(setResumeFormat('pdf'));
            setWaiting(true);
        }
    }
    return (<>
        {status('downloadbox') && <><div className="transparent-popup-bg"></div>
            <div className="custom-skip-popup">

                {!waiting && <><div className="close-btn-icon">
                    <button className="close-icon"
                        onClick={() => {
                            unsetEntity();
                            removeLocalItems();
                            dispatch(setResumeFormat('pdf'));
                            close();
                        }}>Close</button>
                </div></>}
                <div className="content-box">
                {!entity?.type ? <><div style={{marginBottom: '10px'}}><img src="/assets/images/animated-sandbox.gif" alt="download" width="100" /></div><div id="foo" className="copy-label center" style={{ height: '25px', width: '291px' }}>Loading...</div></> : <><h4>{waiting ? `Downloading ${entity.name}` : `Download ${entity.name}`}</h4>
                    <p style={{marginBottom: '10px'}}>{entity.type == 'coverletter' ? getLetterName() :  getResumeName()}</p>
                    {waiting ? <><div style={{marginBottom: '10px'}}><img src="/assets/images/animated-sandbox.gif" alt="download" width="100" /></div><div id="foo" className="copy-label center" style={{ height: '25px', width: '291px' }}>{downloadText}</div></> :
                        <>
                            <div className="copy-label center">Choose your download format</div>
                            <div className="share-link">&nbsp;</div>
                            <div className="download-icons-area">
                                <ul className="download-icons-list">
                                    <li className={`${(activeFormat === 'pdf' ? 'format-active' : '')}`}>
                                        <input 
                                            id="resume_format" 
                                            type="radio" 
                                            name="resume_format" 
                                            defaultChecked    
                                            value="pdf" 
                                            onChange={(e) => entityFormatHandler(e)} 
                                        />
                                        <label htmlFor="resume_format">Adobe PDF (.pdf)</label>
                                    </li>
                                    <li className={`${(activeFormat === 'docx' ? 'format-active' : '')}`}>
                                        <input 
                                            id="resume_format_docx" 
                                            type="radio" 
                                            name="resume_format" 
                                            value="docx" 
                                            onChange={(e) => entityFormatHandler(e) } 
                                        />
                                        <label htmlFor="resume_format_docx">Microsoft Word (.docx)</label>
                                    </li>
                                    {/* <li className={`${((typeof data != 'undefined' && data.plan != 'pro') || activeFormat === 'text') ? 'format-active' : ''}`}> */}
                                    <li className={`${(activeFormat === 'text' ? 'format-active' : '')}`}>
                                        <input 
                                            id="resume_format_txt" 
                                            type="radio" 
                                            name="resume_format" 
                                            //checked={((typeof data != 'undefined' && data.plan != 'pro') || activeFormat === 'text') ? true : false} 
                                            value="text" 
                                            onChange={(e) => entityFormatHandler(e) } 
                                        />
                                        <label htmlFor="resume_format_txt">Plain Text (.txt)</label>
                                    </li>
                                </ul>
                            </div>
                            <div className="button-area">
                                <button className="no-skip" onClick={() => {
                                    leftButtonClickHandler();
                                }}>Cancel</button>
                                <button className="skip" onClick={() => {
                                    rightButtonClickHandler(),
                                    activeFormat != 'text' ? showDownloadProgress() : setDownloadText('Preparing to download');
                                }}>Continue</button>
                            </div>
                        </>}
                        </>}
                </div>
            </div></>}
    </>)
}
export default connect(state => state)(DownloadPopup);

